import { render, staticRenderFns } from "./defect_register.vue?vue&type=template&id=33c05f20&"
import script from "./defect_register.vue?vue&type=script&lang=js&"
export * from "./defect_register.vue?vue&type=script&lang=js&"
import style0 from "./defect_register.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports